import { createHTTPActions } from '../utils';

enum EClaimsAction {
  getClaims = '[Claims] Get Claims',
}

const [getClaims, getClaimsSuccess, getClaimsError] = createHTTPActions<void, string[], void>(EClaimsAction.getClaims);

export const CLAIMS_ACTIONS = {
  getClaims,
  getClaimsSuccess,
  getClaimsError,
};
